import moment from 'moment';

export const compareDates = (a, b) => {
  return moment(a).valueOf() - moment(b).valueOf();
};

export const formatDate = (date, options = {}) => {
  const format = options ? options.format : undefined;

  if (date == null) {
    return '';
  }

  if (typeof date === 'string' && (date.includes('T') || date.match(/[+-]\d{2}:\d{2}$/))) {
    return moment(date).local().format(format);
  }

  // Legacy format support: "yyyy-MM-dd HH:mm" (for backward compatibility)
  if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/.test(date)) {
    return moment.utc(date, "YYYY-MM-DD HH:mm").local().format(format);
  }

  return moment(date).format(format);
};

export const parseDate = (date, format) => {
  return moment(date, format).toDate();
};